import React from 'react';
import ReactDOM from 'react-dom/client';

import TodayPageOpeningHours from './TodayPageOpeningHours';

const root = ReactDOM.createRoot(
  document.getElementById('today_page_opening_hours')
);

root.render(
  <React.StrictMode>
    <TodayPageOpeningHours />
  </React.StrictMode>
);
